import { Redirect } from './ui';

export const Appointment = () => {
  return <Redirect />;
};
